import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { NavbarListButton } from '../Layout/NavbarListButton';
import { filterSameColor, iconButtonStyle, isLightColor } from '../../utils/styles';
import './ColorControl.css';

const selector = ({ configuration }) => ({
  configuration,
});

const ColorControl = (props) => {
  const { configuration } = useStore(selector);
  var currentStyle = props?.editorState?.getCurrentInlineStyle(props.editorState.getSelection());

  // Chercher la couleur appliquée selon le format original
  let currentColor = null;

  if (props.colors && Array.isArray(props.colors)) {
    currentColor = props.colors.find((color) => {
      if (color.label === 'white' || color.label === 'black') {
        // Pour white/black, chercher sans préfixe
        return currentStyle?.has(color.label);
      } else {
        // Pour les autres couleurs, chercher avec le préfixe color_
        return currentStyle?.has(color.label);
      }
    });
  }

  // Si aucune couleur n'est trouvée, utiliser la couleur par défaut. Elle arrive
  // tantôt en objet couleur, tantôt par son seul libellé (volets, cartes info,
  // cf. textStyle?.color?.label dans RichEditor / BoxDraftText) : sans le
  // résoudre en couleur, il n'a pas de `style` et la lettre ne s'y teinte pas.
  if (!currentColor) {
    const resolveColor = (color) => (typeof color === 'string'
      ? [...(props.colors ?? []), ...(configuration?.colors ?? [])].find(({ label }) => label === color)
      : color);
    currentColor = resolveColor(props.defaultColor) ?? resolveColor(configuration?.baseFontColor);
  }

  const { t } = useTranslation();

  // Contour (cf. ColorControl.css) pour une couleur proche du blanc (blanc, gris
  // clair, jaune pâle...), qui se confondrait sinon avec le fond du bouton.
  const isLight = isLightColor(currentColor?.style);

  return (
    <NavbarListButton
      title={t('font-color')}
      disabled={false}
      icon={
        <p
          className={`font-color-indicator${isLight ? ' font-color-indicator--outlined' : ''}`}
          style={{ ...iconButtonStyle(), fontFamily: 'monospace', '--font-color-indicator': currentColor?.style }}
        >
          A
        </p>
      }
      colorInIcon
      onListElementClick={props.onToggle}
      listElements={props.colors ? filterSameColor(props.colors.filter((c) => c.label !== 'transparent')) : []}
      selectedElement={currentColor}
      isOpen={props.isOpen}
      onToggleOpen={props.onToggleOpen}
    />
  );
};

export default ColorControl;
